<template>
    <v-container>
        <v-row>
            <v-col>
                <div
                    :class="{
                        'display-3': $vuetify.breakpoint.mdAndUp,
                        'display-2': $vuetify.breakpoint.smAndDown,
                    }"
                    class="font-weight-bold"
                >
                    Tutorial
                </div>
                <div class="text-center mt-10">
                    <!-- width="560"
                    height="315" -->
                    <iframe
                        width="1008"
                        height="567"
                        :src="tutorial_path"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                </div>
                <v-row>
                    <v-col cols="12" offset-md="8" md="2">
                        <v-btn block color="secondary" @click="previousStep">
                            Atrás
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-btn block color="secondary" @click="nextStep">
                            Siguiente
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "WatchTutorial",
    methods: {
        previousStep() {
            this.$emit("previousStep");
        },
        nextStep() {
            this.$emit("nextStep");
        },
        ...mapActions({
            setPrograms: "tutorial/setPrograms"
        }),
    },
    created() {
        this.setPrograms();
    },
    computed: {
        tutorial_path: function() {
            for (let i in this.programs) {
                if (this.programs[i].id == this.userData.selected_program) {
                    let url = this.programs[i].tutorial_link.replace('watch?v=', 'embed/');
                    return url;
                }
            }
            return "https://www.youtube.com/embed/yP69gvWFt-s";
        },
        ...mapGetters({
            userData: "me/userData",
            programs: "tutorial/programs",
        }),
    },
};
</script>

<style lang="scss" scoped>
.plans div {
  cursor: pointer;
  background-color: #3cf;
  color: white;
  width: 100%;
  margin: 10px;
  padding: 2px 10px;
  font-weight: bold;
  border-radius: 5px;
  &.selected {
    background-color: yellow;
    color: #3cf;
  }
  &:first-child {
    background-color: transparent;
  }
  span {
    margin: auto;
  }
}
</style>
